<template>
  <div>
    <footer class="footer">
      <div class="clearfix"></div>
      <div class="icon-row">
        <div class="footer-icon">
          <h5 class="footer-icon-child footer-icon-child-4"></h5>
          <span class="footer-icon-text">源头厂家</span>
        </div>
        <div class="footer-icon">
          <h5 class="footer-icon-child"></h5>
          <span class="footer-icon-text">云端海选</span>
        </div>
        <div class="footer-icon">
          <h5 class="footer-icon-child footer-icon-child-2"></h5>
          <span class="footer-icon-text">快速进货</span>
        </div>
        <div class="footer-icon">
          <h5 class="footer-icon-child footer-icon-child-3"></h5>
          <span class="footer-icon-text">轻松卖货</span>
        </div>
      </div>
      <div class="service-intro">
        <div class="servece-type">
          <!-- <div class="servece-type-info" v-for="(guide, index) in guideArr" :key="index">
            <ul>
              <li v-for="(item, index) in guide" :key="index">{{item}}</li>
            </ul>
          </div> -->
          <div class="friend-link-item">
            <ul>
              <li v-for="(link, index) in moreLinkAbout" :key="index">
                <router-link :to="link.url" v-if="link.type == 'page'">
                  <span :class="[linkItemClass, {'link-last-item': index === 2}]">{{link.name}}</span>
                </router-link>
                <a :href="link.url" target="_blank" v-if="link.type == 'link'">
                  <span :class="[linkItemClass, {'link-last-item': index === 2}]">{{link.name}}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="friend-link">
          <div class="friend-link-item">
            <ul>
              <li v-for="(link, index) in moreLink" :key="index">
                <span :class="[linkItemClass, {'link-last-item': index === 2}]">{{link}}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="copyright">
          <!--  -->
          <p>Copyright © 2022 by 酷摇科技云采 {{domain}} <a href="https://beian.miit.gov.cn/" class="icp-num">{{icpNum}}</a></p>
          <!-- <span class="thanks">特别鸣谢 Gavin 提供商城模板技术支持 <a href="https://github.com/PowerDos"><Icon type="social-github" class="github-icon"></Icon></a></span> -->
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  created () {
    console.log('url--------', window.location.hostname)

    // 20220817
    // 默认icpNum指定给 www.coooyooo.com
    // 如果是另外2个域名，则动态显示icpNum
    if (window.location.hostname == 'www.kooyooo.com' || window.location.hostname == 'kooyooo.com') {
      this.icpNum = '沪ICP备19032761号-7';
      this.domain = 'www.kooyooo.com';
    }
    if (window.location.hostname == 'www.koooyao.com' || window.location.hostname == 'koooyao.com') {
      this.icpNum = '沪ICP备19032761号-3';
      this.domain = 'www.koooyao.com';
    }
  },
  data () {
    return {
      domain: 'www.coooyooo.com',
      icpNum: '沪ICP备19032761号-5', // www.coooyooo.com
      // icpNum: '沪ICP备19032761号-7', // www.kooyooo.com
      // icpNum: '沪ICP备19032761号-3', // www.koooyao.com

      linkItemClass: 'link-item',
      // guideArr: [
      //   [ '购物指南', '购物流程', '会员介绍', '生活旅行', '常见问题', '大家电', '联系客服' ],
      //   [ '配送方式', '上门自提', '211限时达', '配送服务查询', '收取标准', '海外配送' ],
      //   [ '支付方式', '货到付款', '在线支付', '分期付款', '邮局汇款', '公司转账' ],
      //   [ '售后服务', '售后政策', '价格保护', '退款说明', '返修/退换货', '取消订单' ]
      // ],
      moreLinkAbout: [
        {
          name: '关于酷摇科技云采',
          url: '/aboutUs',
          type: 'page'
        },
        // {
        //   name: '更多关于酷摇科技',
        //   url: 'http://xkmobi.com/',
        //   type: 'link'
        // },
        {
          name: '用户使用协议',
          url: '../../../static/file/koooyooo_user_agreement.pdf',
          type: 'link'
        },
        {
          name: '联系我们',
          url: '/contactUs',
          type: 'page'
        },
      ],

      // moreLink: [
      //   '关于我们', '联系我们', '联系客服', '合作招商', '商家帮助', '营销中心', '销售联盟', '校园社区', '风险监测', '隐私政策'
      // ]
      moreLink: [
        '上海小快网络科技有限公司', '400-150-6885', '中国（上海）自由贸易区临港新片区东征路133号556室'
      ]
    };
  }
};
</script>

<style scoped>
/*****************************底 部 开 始*****************************/
.github-icon {
  color: #ccc !important;
}
.thanks {
  color: #ccc !important;
}
.icp-num {
  font-size: 12px !important;
  text-decoration: underline;
}
.footer {
  width: 100%;
  height: 390px;
  margin-top: 30px;
  /*background-color: #eaeaea;*/
  background-color: #fafafa;
}
.icon-row {
  margin: 15px auto;
  padding-top: 8px;
  width: 1000px;
  height: 64px;
  text-align: center;
}
.footer-icon {
  margin-left: 17px;
  margin-right: 17px;
  /*float: left;*/
  display: inline-block;
}
.footer-icon-child {
  margin-top: 10px;
  overflow: hidden;
  position: absolute;
  width: 36px;
  height: 42px;
  background-image: url("../../../static/img/footer/ico_service.png");
  text-indent: -999px;
}
.footer-icon-child-2 {
  background-position: 0 -43px;
}
.footer-icon-child-3 {
  background-position: 0 -86px;
}
.footer-icon-child-4 {
  background-position: 0 -129px;
}
.footer-icon-text {
  margin-left: 45px;
  color: #444444;
  font-size: 18px;
  font-weight: bold;
  line-height: 64px;
}
.service-intro {
  width: 100%;
  border-top: 1px solid #b2dfdb;
}
.servece-type {
  margin: 15px auto;
  /* 20221002 remove height for less content display */
  /*height: 200px;*/ 
  width: 800px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.servece-type-info {
  color: #666666;
}
.servece-type-info ul {
  list-style: none;
}
.servece-type-info li {
  font-size: 14px;
  cursor: pointer;
  line-height: 26px;
}
.servece-type-info li:first-child {
  font-size: 16px;
  line-height: 28px;
  font-weight: bold;
}
.friend-link {
  display: flex;
  align-items: center;
  width: 908px;
  height: 30px;
  margin: 0px auto;
  color: #666;
  border-top: 1px solid #b2dfdb;
}
.friend-link-item {
  margin: 0px auto;
}
.friend-link-item ul {
  list-style: none;
}
.friend-link-item li {
  padding: 5px 0px;
  float: left;
}
.link-item {
  padding: 0px 8px;
  /*cursor: pointer;*/
  border-right: 1px solid #ccc;
}
.link-last-item {
  border: none;
}
.copyright {
  width: 100%;
  color: #666;
  line-height: 30px;
  text-align: center;
}
.copyright a{
  color: #232323;
  font-size: 20px;
}
/*****************************底 部 结 束*****************************/
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue